import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, model, Output } from '@angular/core';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
} from '@app/components/button';
import { DialogComponent } from '@app/components/dialog';
import {
  TextAlign,
  TextColor,
  TextComponent,
  TextHeight,
  TextSize,
  TextType,
  TextWeight,
} from '@app/components/text';
import {
  ViewAlign,
  ViewComponent,
  ViewDirection,
  ViewJustify,
  ViewSpacing,
} from '@app/components/view';
import { Spacing } from '@app/shared/types';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [
    DialogComponent,
    CommonModule,
    ButtonComponent,
    ViewComponent,
    TextComponent,
  ],
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
  isOpen = model(false);
  @Input() title!: string;
  @Input() subTitle!: string;
  @Input() primaryDisabled = false;
  @Input() primaryText!: string;
  @Input() secondaryText!: string;
  @Input() headerPlacement = ViewAlign.CENTER;
  @Input() buttonPlacement = ViewAlign.CENTER;
  @Input() headerGap = Spacing.MEDIUM;
  @Input() contentGap = Spacing.X_LARGE;
  @Input() buttonSize = ButtonSize.LARGE;
  @Input() secondaryButtonType = ButtonType.SECONDARY;
  @Input() titleAlignment = TextAlign.LEFT;
  @Input() open!: boolean;
  @Output() handlePrimaryButton = new EventEmitter<void>();
  @Output() handleSecondaryButton = new EventEmitter<void>();
  ButtonType = ButtonType;
  ViewSpacing = ViewSpacing;
  ViewDirection = ViewDirection;
  ViewJustify = ViewJustify;
  ViewAlign = ViewAlign;
  TextSize = TextSize;
  TextHeight = TextHeight;
  TextWeight = TextWeight;
  TextColor = TextColor;
  TextType = TextType;
  TextAlign = TextAlign;

  handlePrimaryButtonPass() {
    this.handlePrimaryButton.emit();
  }

  handleSecondaryButtonPass() {
    this.handleSecondaryButton.emit();
  }
}
